import { render } from "./customerlist.vue?vue&type=template&id=50f4690a&scoped=true"
import script from "./customerlist.vue?vue&type=script&lang=js"
export * from "./customerlist.vue?vue&type=script&lang=js"

import "./customerlist.vue?vue&type=style&index=0&id=50f4690a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f4690a"]])

export default __exports__